import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { AppContext, SeoService } from './../../shared';
import { BlogPage } from  './../blog-page';

@Component({
  selector: 'linescape-exhibit-intermodal-europe',
  template: require('./linescape-exhibit-intermodal-europe.component.html'),
  styles: [require('./../blog.component.scss'), require('./linescape-exhibit-intermodal-europe.component.scss')]
})
export class LinescapeExhibitIntermodalEuropeComponent extends BlogPage {
  title = "Linescape Exhibits at Intermodal Europe - Linescape";
  description = "Search Engine to showcase Data Solutions at Intermodal, Nov. 29 - 30, 2011";

  constructor(route: ActivatedRoute, app: AppContext, seo: SeoService) {
    super(route, app, seo);
  }
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/press/linescape-exhibit-intermodal-europe/linescape-exhibit-intermodal-europe.component.ts